import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import { Game, Auth } from '../../Core'
import * as MapSelectors from '../../Mars/Map/map.selectors'
import * as tutorialActions from '../tutorial.actions'
import * as battlesSelectors from '../../Mars/Battles/battles.selectors'
import * as tutorialSelectors from '../tutorial.selectors'

import UpgradePanel from '../../Mars/Map/MapScreen/TilePopup/UpgradePanel/UpgradePanel'

const mapStateToProps = (state) => {
  return {
    selectedTile: MapSelectors.getSelectedTile(state),
    cursorPos: Game.selectors.getCursorPosition(state),

    // To mock ?
    userInfo: Auth.selectors.getUserInfo(state),
    parameters: MapSelectors.getBuildingParameters(state),
    attacking: MapSelectors.getAttackState(state),

    // To mock
    visitorMap: tutorialSelectors.getVisitorMap(state),
    visitorInfo: tutorialSelectors.getVisitorInfo(state),
    battles: battlesSelectors.getUserBattles(state),

    playersList: tutorialSelectors.getPlayerList(state),
    currentPhase: tutorialSelectors.getCurrentPhase(state),
    userMap: tutorialSelectors.getUserMap(state),
    buildings: MapSelectors.getBuildings(state),
    userData: tutorialSelectors.getUserData(state),
    isTutorialMode: tutorialSelectors.isTutorialMode(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // To mock?
    createBattle: bindActionCreators(tutorialActions.createBattle, dispatch),
    setIndividualBattle: bindActionCreators(tutorialActions.setIndividualBattle, dispatch),
    destroyBuilding: console.log('destroy Building'),
    repareBuilding: console.log('repare building'),

    // mocked
    upgradeBuilding: bindActionCreators(tutorialActions.upgradeBuilding, dispatch),
    createBuilding: bindActionCreators(tutorialActions.createBuilding, dispatch),
    addScreen: bindActionCreators(tutorialActions.addScreen, dispatch),
    removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
    removePopup: bindActionCreators(tutorialActions.removePopup, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UpgradePanel))
